var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("cargo-advance-select", {
    attrs: {
      disabled: _vm.disabled,
      "select-type": _vm.TYPE_NAMES.static_data_User,
      "method-params": _vm.methodParams,
      cache: false,
      filterable: "",
      "default-value": _vm.defaultValue,
      "default-multiple-value": _vm.defaultMultipleValue,
      "static-options": _vm.options,
      multiple: _vm.multiple,
      "show-custom-label-in-option": _vm.showCustomLabelInOption,
      "custom-label": _vm.customLabel,
      placeholder: _vm.placeholder || undefined,
      clearable: _vm.clearable
    },
    on: {
      parentCallBack: function(p) {
        _vm.$emit("change", p)
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }